import React from 'react'

export const Steps = ({ elements = [], classes = {}, activeStep = 1 }) => {
  const { container } = classes

  return (
    <div className={`steps-wrapper ${container}`}>
      {elements.map(({ classNameText = '', classNameIcon = '', iconChildren, text }, i) => {
        let iconClass = ''
        let textClass = ''

        if (i === activeStep) {
          iconClass = 'step-current'
          textClass = 'step-text-current'
        }
        if (i < activeStep) {
          iconClass = 'step-finished'
          textClass = 'step-text-finished'
        }
        if (i > activeStep) {
          iconClass = 'step-next'
          textClass = 'step-text-next'
        }

        return (
          <React.Fragment key={i}>
            {i !== 0 ? <div className="line-flex" /> : null}
            <div className="step-box">
              <div className={`${classNameIcon} ${iconClass}`}>{iconChildren}</div>
              <div className={`${classNameText} ${textClass}`}>{text}</div>
            </div>
          </React.Fragment>
        )
      })}
    </div>
  )
}
